import '@vebox/etui-system';
import { createElement } from 'react';
import { b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import InputAddon from '../InputAddon/InputAddon.js';

const DropdownIndicator = ({
  innerProps,
  selectProps: {
    endInputAddon,
    size,
    menuIsOpen
  }
}) => {
  return endInputAddon || /*#__PURE__*/createElement(InputAddon, _extends({
    size: size,
    position: "end"
  }, innerProps, {
    styles: {
      root: {
        position: 'relative',
        top: 'auto',
        display: 'flex',
        alignItems: 'center'
      }
    }
  }), /*#__PURE__*/createElement(Icon, {
    size: 24,
    rotate: menuIsOpen ? 180 : 0,
    styles: {
      root: {
        transition: '0.3s'
      }
    },
    glyph: icons.CHEVRON_DOWN
  }));
};

export default DropdownIndicator;
